import { render, staticRenderFns } from "./Revoke.vue?vue&type=template&id=40a16581&scoped=true&"
import script from "./Revoke.vue?vue&type=script&lang=js&"
export * from "./Revoke.vue?vue&type=script&lang=js&"
import style0 from "./Revoke.vue?vue&type=style&index=0&id=40a16581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a16581",
  null
  
)

export default component.exports